import {Settings} from '../Settings';

// The admin tools are only downloaded once /me says the logged-in player is an admin.
export const watchAdminTools = (ui, backendManager) => {
	if(!Settings.adminTools) return;

	let tools = null;
	let loading = null;
	// A new login keeps the previous player's userData until /me answers.
	let confirmed = !!backendManager.userData;

	const isAdmin = () => confirmed && backendManager.isLoggedIn() && backendManager.userData?.is_admin === true;

	const remove = () => {
		if(!tools) return;
		tools.destroy();
		tools = null;
		ui.setAdmin(null);
	};

	const update = () => {
		if(!isAdmin()) return remove();
		if(tools || loading) return;
		loading = import('./adminTools.js').then(({AdminTools}) => {
			if(!isAdmin() || tools) return;
			tools = new AdminTools(ui, backendManager);
			ui.setAdmin(tools);
		}).catch(error => console.error('Admin tools failed to load', error)).finally(() => {
			loading = null;
		});
	};

	backendManager.registerListener('login', () => {
		confirmed = false;
		remove();
	});
	backendManager.registerListener('logout', remove);
	backendManager.registerListener('userdata', () => {
		confirmed = true;
		update();
	});
	update();
};
